import { render, staticRenderFns } from "./ring-group-manage-teaminbox.vue?vue&type=template&id=0f36f73a"
import script from "./ring-group-manage-teaminbox.vue?vue&type=script&lang=js"
export * from "./ring-group-manage-teaminbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports